import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useThemeColor } from "@/hooks/useThemeColor";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Reset theme-color to default on every route change.
  // Pages with custom colors (PublicProfile, Index) override via their own useThemeColor call.
  useThemeColor(undefined);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
